import TXRecord from './index';

export default { path: '/home/txRecord', component: TXRecord };
